<template>
  <div class="wallet-card-list">
    <slot />
  </div>
</template>

<script>
export default {
  name: "WalletCardList",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.wallet-card-list {
  display: grid;
  align-items: start;
  justify-content: center;

  @include media(pc) {
    grid-template-columns: repeat(3, minmax(0, 370px));
    grid-gap: 24px;
  }
  @include media(sp) {
    grid-gap: 16px;
    grid-template-columns: 1fr;
  }
}
</style>